/**
 * @sw-package fundamentals@after-sales
 * @private
 */
Shopware.Component.register('swag-migration-loading-screen', () => import('./swag-migration-loading-screen'));
Shopware.Component.register('swag-migration-result-screen', () => import('./swag-migration-result-screen'));
